import { render, staticRenderFns } from "./Activity_Details_self.vue?vue&type=template&id=a8639d88&style=height%3A%20100%25%3B"
import script from "./Activity_Details_self.vue?vue&type=script&lang=js"
export * from "./Activity_Details_self.vue?vue&type=script&lang=js"
import style0 from "./Activity_Details_self.vue?vue&type=style&index=0&id=a8639d88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports